
const list = [];


/**
 * 一级菜单的筛选
 * **/
const operateMenu = (powers) => {
  let navList = [];
  if (!powers) {
    return navList;
  }
  for (let x of list) {
    if (x.module && powers[x.module]) {
      navList.push(x);
    }
  }
  return navList;
}

/** 
 * 进入页面前的操作权限判断
*/
const setOperatePower = (standard, to) => {
  let seePower = true,
    operatePower = true,
    editPower = true,
    downloadPower = true,
    exportPower = true,
    printdPower = true,
    preparePower = true,
    classPower = true,
    sharePower = true;

  let power = JSON.parse(localStorage.getItem('power_mvr_student'));


  if (power) {
    let have = power[to.meta.module];
    if (!have) {
      return {
        seePower,
        operatePower,
        editPower,
        exportPower,
        printdPower,
        downloadPower,
        preparePower,
        classPower,
        sharePower
      };
    }
    if (have.includes('MANAGE')) {
      return {
        seePower,
        operatePower,
        editPower,
        exportPower,
        printdPower,
        downloadPower,
        preparePower,
        classPower,
        sharePower
      };
    }

    if (!have.includes('MODULE')) {
      seePower = false;
    }
    if (!have.includes('EDIT')) {
      editPower = false;
    }
    if (!have.includes('DOWNLOAD') && !have.includes('NDOWNLOAD')) {
      downloadPower = false;
    }
    if (!have.includes('EXPORT')) {
      exportPower = false;
    }
    if (!have.includes('PRINT')) {
      printdPower = false;
    }
    if (!have.includes('PREPARE')) {
      preparePower = false;
    }
    if (!have.includes('CLASS')) {
      classPower = false;
    }
    if (!have.includes('SHARE')) {
      sharePower = false;
    }

  }

  return {
    seePower,
    operatePower,
    editPower,
    downloadPower,
    exportPower,
    printdPower,
    preparePower,
    classPower,
    sharePower
  };

}

/** 
 * 二级菜单权限--显示/隐藏
*/
const setAuthority = (menuList) => {
  let list = [...menuList];
  return list;

  let power = JSON.parse(localStorage.getItem('power_mvr_student'));

  for (let i = 0; i < list.length; i++) {
    let x = list[i];
    if (power && power[x.module]) {
      x.author = power[x.module]
    } else {
      list.splice(i, 1);
      i--;
    }
  }
  return list;

}
export {
  list,
  operateMenu,
  setOperatePower,
  setAuthority
};
